module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('DModal', {
    staticStyle: {
      "z-index": "12312312312312"
    },
    attrs: {
      "show-close": false,
      "isBgOverlay": true,
      "appendToBody": true,
      "placeInTop": _vm.isSalaryIntegrationActive
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('div', {
    staticClass: "d-modal text-dark",
    class: {
      'd-modal--full-width': _vm.isSalaryIntegrationActive
    },
    attrs: {
      "slot": "insertComponent",
      "id": "d-create-task-for-user"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__content",
    class: {
      'd-modal__content--no-employments': _vm.filteredEmployment.length === 0
    }
  }, [_c('table', {
    staticClass: "do-table",
    class: {
      'do-table--max-width': !_vm.isSalaryIntegrationActive
    }
  }, [_c('thead', [(_vm.isSalaryIntegrationActive) ? [_c('th', [_vm._v("Ansættelse")]), _vm._v(" "), _c('th', [_vm._v("Ansættelsesnummer")]), _vm._v(" "), _c('th', [_vm._v("Organisation")]), _vm._v(" "), _c('th', [_vm._v("Skabelon")]), _vm._v(" "), _c('th', {
    staticClass: "td-subsalary-toggler"
  }, [_vm._v("Vikarløn")]), _vm._v(" "), _c('th', {
    staticClass: "td-lonart"
  }, [_vm._v("Standard lønkode")]), _vm._v(" "), _c('th', [_vm._v("Stabdard omkostningsted")])] : [_c('th', [_vm._v("\n            Ansættelse\n          ")]), _vm._v(" "), (_vm.filteredEmployment.length !== 0) ? _c('th', {
    staticClass: "center"
  }, [_vm._v("\n            Vikarløn\n          ")]) : _vm._e(), _vm._v(" "), _c('th', {
    staticClass: "td--delete"
  })]], 2), _vm._v(" "), _c('tbody', [(_vm.filteredEmployment.length === 0) ? _c('tr', [_c('td', {
    staticClass: "text-explainer",
    staticStyle: {
      "font-weight": "normal"
    }
  }, [_vm._v("Ingen aktive ansættelser")])]) : _vm._e(), _vm._v(" "), _vm._l((_vm.filteredEmployment), function(employment) {
    return _c('tr', {
      key: employment.id,
      class: {
        'employment--error': employment.v_has_error
      }
    }, [(_vm.isSalaryIntegrationActive) ? [_c('td', [_vm._v(_vm._s(employment.source_title ? employment.source_title : employment.title))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(employment.employment_number))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(employment.organisation))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "spinner-flex"
    }, [_c('select', {
      staticClass: "do-select",
      domProps: {
        "value": employment.employment_template_id
      },
      on: {
        "change": function($event) {
          return _vm.setEmploymentTemplate(employment, $event.target.value)
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.employmentTemplates), function(s) {
      return _c('option', {
        key: s.id,
        domProps: {
          "value": s.id
        }
      }, [_vm._v("\n                    " + _vm._s(s.title) + "\n                  ")])
    })], 2), _vm._v(" "), (_vm.isSavingTemplate) ? _c('div', {
      staticClass: "do-spinner"
    }) : _vm._e()])]), _vm._v(" "), _c('td', {
      staticClass: "td-subsalary-toggler"
    }, [(employment.employment_template_id) ? _c('div', {
      staticClass: "d-input-group--toggler",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setIsManualSalary(employment, !employment.manual_salary)
        }
      }
    }, [_c('AppToggle', {
      attrs: {
        "allowChanges": false,
        "propOn": employment.manual_salary
      }
    })], 1) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "td-lonart"
    }, [(employment.manual_salary) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employment.salary_code_id),
        expression: "employment.salary_code_id"
      }],
      staticClass: "do-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(employment, "salary_code_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, [_c('option', {
      attrs: {
        "disabled": "",
        "value": ""
      }
    }), _vm._v(" "), _vm._l((_vm.salaryCodes), function(s) {
      return _c('option', {
        key: s.id,
        domProps: {
          "value": s.id
        }
      }, [_vm._v("\n                  " + _vm._s(s.vTitle) + "\n                ")])
    })], 2) : _vm._e()]), _vm._v(" "), _c('td', [(employment.manual_salary) ? _c('select', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: (employment.default_omkostningssted),
        expression: "employment.default_omkostningssted"
      }],
      staticClass: "do-select",
      on: {
        "change": function($event) {
          var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
            return o.selected
          }).map(function(o) {
            var val = "_value" in o ? o._value : o.value;
            return val
          });
          _vm.$set(employment, "default_omkostningssted", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
        }
      }
    }, _vm._l((_vm.costCenters), function(costCenter) {
      return _c('option', {
        key: costCenter.code,
        domProps: {
          "value": costCenter.code
        }
      }, [_vm._v("\n                  " + _vm._s(costCenter.title) + "\n                ")])
    }), 0) : _vm._e()])] : _vm._e(), _vm._v(" "), (!_vm.isSalaryIntegrationActive) ? [_c('td', [_vm._v(_vm._s(employment.title))]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "d-input-group--toggler d-input-group--toggler--manual",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.setIsManualSalary(employment, !employment.manual_salary)
        }
      }
    }, [_c('AppToggle', {
      attrs: {
        "allowChanges": false,
        "propOn": employment.manual_salary
      }
    })], 1)]), _vm._v(" "), _c('td', {
      staticClass: "td--delete"
    }, [_c('div', {
      directives: [{
        name: "tippy",
        rawName: "v-tippy",
        value: ({
          arrow: false,
          placement: 'right',
          animateFill: false,
          animation: 'shift-away',
          zIndex: '999999992',
          boundary: 'window'
        }),
        expression: "{\n              arrow: false,\n              placement: 'right',\n              animateFill: false,\n              animation : 'shift-away',\n              zIndex: '999999992',\n              boundary: 'window'}"
      }],
      staticClass: "icon__bg-circle icon__bg-circle--danger",
      attrs: {
        "content": employment['can_delete?'] ? 'Slet ansættelsen' : 'Arkiver ansættelsen'
      },
      on: {
        "click": function($event) {
          return _vm.setDeleteEmployment(employment)
        }
      }
    }, [(employment['can_delete?']) ? _c('span', {
      staticClass: "icon-bin"
    }) : _c('svg', {
      staticClass: "tw-icon",
      attrs: {
        "xmlns": "http://www.w3.org/2000/svg",
        "viewBox": "0 0 24 24",
        "fill": "currentColor"
      }
    }, [_c('path', {
      attrs: {
        "d": "M3.53 2.47a.75.75 0 00-1.06 1.06l18 18a.75.75 0 101.06-1.06l-18-18zM22.676 12.553a11.249 11.249 0 01-2.631 4.31l-3.099-3.099a5.25 5.25 0 00-6.71-6.71L7.759 4.577a11.217 11.217 0 014.242-.827c4.97 0 9.185 3.223 10.675 7.69.12.362.12.752 0 1.113z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M15.75 12c0 .18-.013.357-.037.53l-4.244-4.243A3.75 3.75 0 0115.75 12zM12.53 15.713l-4.243-4.244a3.75 3.75 0 004.243 4.243z"
      }
    }), _vm._v(" "), _c('path', {
      attrs: {
        "d": "M6.75 12c0-.619.107-1.213.304-1.764l-3.1-3.1a11.25 11.25 0 00-2.63 4.31c-.12.362-.12.752 0 1.114 1.489 4.467 5.704 7.69 10.675 7.69 1.5 0 2.933-.294 4.242-.827l-2.477-2.477A5.25 5.25 0 016.75 12z"
      }
    })])])])] : _vm._e()], 2)
  })], 2)]), _vm._v(" "), (_vm.user.v_oldEmployments && _vm.user.v_oldEmployments.length > 0) ? _c('p', {
    staticClass: "text-link pointer marg-1-top",
    on: {
      "click": _vm.setIsShowOldEmployment
    }
  }, [(!_vm.isShowOldEmployment) ? [_vm._v("Se")] : [_vm._v("Skjul")], _vm._v("\n        arkiverede ansættelser\n      ")], 2) : _vm._e(), _vm._v(" "), (_vm.isShowOldEmployment) ? _c('ul', _vm._l((_vm.user.v_oldEmployments), function(employment) {
    return _c('li', {
      staticClass: "d-employment-item d-employment-item--deleted"
    }, [_vm._v("\n          " + _vm._s(employment.title) + "\n        ")])
  }), 0) : _vm._e()]), _vm._v(" "), (_vm.filteredEmployment.length !== 0) ? _c('div', {
    staticClass: "d-modal__footer"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [_vm._v("Annuller")]), _vm._v(" "), _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    class: {
      'do-bttn--submit--loading': _vm.isSaving
    },
    on: {
      "click": _vm.saveChanges
    }
  }, [_vm._v("\n        Gem\n      ")])]) : _vm._e(), _vm._v(" "), (_vm.theDeleteEmployment) ? _c('DModal', {
    attrs: {
      "showClose": false
    }
  }, [_c('div', {
    staticClass: "d-modal__delete-employment",
    attrs: {
      "slot": "insertComponent"
    },
    slot: "insertComponent"
  }, [_c('div', {
    staticClass: "d-modal__header"
  }, [_c('h2', [_vm._v("Er du sikker?")]), _vm._v(" "), _c('div', {
    staticClass: "font-large icon__bg-circle d-modal__header__close",
    on: {
      "click": function($event) {
        _vm.theDeleteEmployment = null
      }
    }
  }, [_c('span', {
    staticClass: "icon-cross2"
  })])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__body"
  }, [_c('p', [_vm._v("Er du sikker på, at du vil du " + _vm._s(_vm.theDeleteEmployment['can_delete?'] ? 'slette' : 'arkivere') + "\n            ansættelsen som "), _c('b', [_vm._v(_vm._s(_vm.theDeleteEmployment.title))]), _vm._v(" for\n            "), _c('b', [_vm._v(_vm._s(_vm.user.name))]), _vm._v(" hos "), _c('b', [_vm._v(_vm._s(_vm.school.name ? _vm.school.name : 'docendo'))])]), _vm._v(" "), _c('br'), _vm._v(" "), (_vm.theDeleteEmployment['can_delete?']) ? _c('p', [_c('i', [_vm._v("Bemærk: Ansættelsen har ikke været brugt, og vil derfor\n            blive slettet permanent.")])]) : _c('p', [_c('i', [_vm._v("Bemærk: Ansættelsen har været brugt og vil derfor blive arkiveret, så den ikke kan anvendes\n            igen. Tidligere data vil dog ikke blive slettet.")])]), _vm._v(" "), _c('div', {
    staticClass: "d-modal__buttons"
  }, [_c('button', {
    staticClass: "do-bttn",
    on: {
      "click": function($event) {
        _vm.theDeleteEmployment = null
      }
    }
  }, [_vm._v("Annullér")]), _vm._v(" "), (_vm.theDeleteEmployment['can_delete?']) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.deleteEmployment(_vm.theDeleteEmployment)
      }
    }
  }, [_vm._v("Slet ansættelsen\n            ")]) : _vm._e(), _vm._v(" "), (!_vm.theDeleteEmployment['can_delete?'] && _vm.theDeleteEmployment['can_archive?']) ? _c('button', {
    staticClass: "do-bttn do-bttn--submit",
    on: {
      "click": function($event) {
        return _vm.archiveEmployment(_vm.theDeleteEmployment)
      }
    }
  }, [_vm._v("\n              Arkiver ansættelsen\n            ")]) : _vm._e()])])])]) : _vm._e()], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-2e5c7d82!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Salary/SalarySettings/SalarySettingsUsersUser.vue
// module id = 1571
// module chunks = 1